import { render } from "./neworder.vue?vue&type=template&id=59177e41"
import script from "./neworder.vue?vue&type=script&lang=js"
export * from "./neworder.vue?vue&type=script&lang=js"

import "./neworder.vue?vue&type=style&index=0&id=59177e41&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__